module.exports = __webpack_public_path__ + "static/img/thumb_14.bcd0ac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_14.jpg
// module id = T8ct
// module chunks = 0